(function () {
  "use strict";

  angular.module("sempraWebapp").component("changeOfParameters", {
    templateUrl:
      "app/facilityKarcherDetails/changeOfParameters/changeOfParameters.html",
    controller: changeOfParameters,
    bindings: {
      changeOfParametersData: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function changeOfParameters($translate) {
    var vm = this;
    vm.iconSource = 'assets/icons/ic_arrow_drop_side_content_black.svg';
    vm.parametersState = {};

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
      vm.desaltingList = [
        {
          value: 0,
          name: $translate.instant("OFF")
        },
        {
          value: 1,
          name: $translate.instant("ON")
        },
        {
          value: 2,
          name: $translate.instant("AUTOMATIC")
        }
      ];
      vm.seasonList = [
        {
          value: 0,
          name: $translate.instant("SPRING_PROGRAM")
        },
        {
          value: 1,
          name: $translate.instant("SUMMER_PROGRAM")
        },
        {
          value: 2,
          name: $translate.instant("AUTUMN_PROGRAM")
        },
        {
          value: 3,
          name: $translate.instant("WINTER_PROGRAM")
        }
      ];
      vm.doorControlList = [
        {
          value: 0,
          name: $translate.instant("OFF")
        },
        {
          value: 1,
          name: $translate.instant("SUMMER_DOOR_CONTROL")
        },
        {
          value: 2,
          name: $translate.instant("WINTER_DOOR_CONTROL")
        }
      ];
    };

    vm.$onChanges = function (changes) {
      if(changes.changeOfParametersData.currentValue) {
        mapToModel(changes.changeOfParametersData.currentValue, true);
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateParameters = function() {
      mapToModel(vm.changeOfParametersData, false);
      vm.activation({
        data: vm.changeOfParametersData
      });
    }

    function mapToModel(parametersList, init) {
      init ? parametersList.forEach(function(parameter) {
        switch (parameter.name) {
          case "SEASON":
            vm.season = parameter.value;
            vm.parametersState.season = parameter.state;
            break;
          case "DOOR_CONTROL":
            vm.doorControl = parameter.value;
            vm.parametersState.doorControl = parameter.state;
            break;
          case "SALT_EXPULSION":
            vm.desalting = parameter.value;
            vm.parametersState.saltExpulsion = parameter.state;
            break;
        }
      }) : parametersList.forEach(function(parameter) {
        switch (parameter.name) {
          case "SEASON":
            parameter.value = vm.season;
            parameter.state = vm.parametersState.season;
            break;
          case "DOOR_CONTROL":
            parameter.value = vm.doorControl;
            parameter.state = vm.parametersState.doorControl;
            break;
          case "SALT_EXPULSION":
            parameter.value = vm.desalting;
            parameter.state = vm.parametersState.saltExpulsion;
            break;
        }
      });
    }

  }
})();
